/* eslint-disable @typescript-eslint/promise-function-async */
import { Routes } from '@angular/router';
import { HomeDataRoutes } from './home-data/home-data.routing';
import { AdditionalDataRoutes } from './additional-data/additional-data.routing';
import { ConfirmDataRoutes } from './confirm-data/confirm-data.routing';
import { PolicyDataRoutes } from './policy-data/policy-data.routing';
import { PolicyHolderDataRoutes } from './policy-holder-data/policy-holder-data.routing';
import { RoutePaths } from '@global/routePaths';
import { NavigationGuard } from '@core/guards/navigation.guard';

export const ModifyQuotation: Routes = [
  {
    path: RoutePaths.MODIFY_QUOTATION.PROJECT_SUMMARY.route,
    loadChildren: () =>
      import('@pages/modify-project-summary/modify-project-summary.module').then(m => m.ModifyProjectSummaryPageModule),
    canActivate: [NavigationGuard],
  },
  ...HomeDataRoutes,
  ...PolicyDataRoutes,
  ...PolicyHolderDataRoutes,
  ...AdditionalDataRoutes,
  ...ConfirmDataRoutes,
];
